module.exports = __webpack_public_path__ + "img/homepage_cta.80dfe700.png";